module.exports = __webpack_public_path__ + "static/media/bg.b5f17158.png";